import { Typography, Alert, message, FormInstance } from "antd";
import { ExportOutlined, CopyOutlined } from "@ant-design/icons";
import React from "react";
import copy from "copy-to-clipboard";

const { Title, Paragraph, Text } = Typography;

interface AffiliateCreateNextStepProps {
  form: FormInstance;
}

export const AffiliateCreateNextStep = ({
  form,
}: AffiliateCreateNextStepProps) => {
  const slug = form.getFieldValue("slug") || "slug";

  const handleCopy = () => {
    copy(slug);
    message.success("Slug gekopieerd");
  };

  const linkStyle: React.CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
  };
  return (
    <div>
      <Alert
        message={<span>Nieuwe affiliate succesvol aangemaakt</span>}
        type="success"
        showIcon
        style={{ marginBottom: 16 }}
      />
      <Typography>
        <Title level={4} style={{ marginTop: 0 }}>
          Volgende stappen
        </Title>
        <Paragraph>
          Na het aanmaken van de affiliate (
          <span
            style={{ display: "inline-flex", alignItems: "center", gap: 4 }}
          >
            <Text code style={{ margin: 0 }}>
              {slug}
            </Text>
            <CopyOutlined
              onClick={() => handleCopy()}
              style={{ cursor: "pointer", fontSize: 14, color: "#1677ff" }}
              aria-label="Kopieer slug"
            />
          </span>
          ) voer je de onderstaande stappen uit om de worker en monitoring in te
          richten.
        </Paragraph>
        <ol>
          <li style={{ marginBottom: 8 }}>
            Maak een PR die een nieuwe worker toevoegt voor deze affiliate.
          </li>
          <li style={{ marginBottom: 8 }}>
            Kopieer het gedrag van een <Text code>worker-xxx</Text> in{" "}
            <Text code>.do/app-spec.yml.tmpl</Text> en vervang{" "}
            <Text code>xxx</Text> door <Text code>{slug}</Text>.
          </li>
          <li style={{ marginBottom: 8 }}>
            Nadat de PR is gemerged en gedeployed op acceptance, deploy naar
            productie via de{" "}
            <Typography.Link
              href="https://github.com/rumble-it/rumbledirect/actions/workflows/deploy-app-prod.yml"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              <Text code style={{ margin: 0 }}>
                deploy-app-prod
              </Text>
              <ExportOutlined style={{ fontSize: 12, opacity: 0.75 }} />
            </Typography.Link>{" "}
            workflow (indien van toepassing).
          </li>
          <li style={{ marginBottom: 8 }}>
            Stel het alert policy kanaal van de nieuwe worker in naar Slack:
            <ul style={{ marginTop: 4, paddingLeft: 18 }}>
              <li>
                Ga naar{" "}
                <Typography.Link
                  href="https://cloud.digitalocean.com/apps"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={linkStyle}
                >
                  <Text strong style={{ margin: 0 }}>
                    DigitalOcean Apps dashboard
                  </Text>
                  <ExportOutlined style={{ fontSize: 12, opacity: 0.75 }} />
                </Typography.Link>{" "}
                en open de betreffende app. Navigeer naar{" "}
                <Text strong>Settings &gt; Alert Policies</Text>.
              </li>
              <li>
                Klik op <Text strong>Edit</Text>.
              </li>
              <li>
                Vervang policies met <Text>Delivery Method = Email</Text> zodat
                ze rapporteren naar Slack (verwijder e-mail en voeg het juiste
                Slack kanaal toe).
              </li>
            </ul>
          </li>
        </ol>
      </Typography>
    </div>
  );
};
